import React, { Component, Fragment } from "react";
import Post from "./Post";
import postService from "../../services/postService";
import CircularLoadingScreen from "../commons/CircularLoadingScreen";
import User from "./../commons/User";
import { Link } from "react-router-dom";

const paddingStyle = { padding: "0 20px" };

class SearchResults extends Component {
  state = {
    loadedResults: false,
    results: [],
  };

  async componentDidMount() {
    const { query, target } = this.props;
    await this.loadResults(query, target);
  }

  loadResults = async (query, target) => {
    if (["posts", "users"].includes(target)) {
      const response = await postService.search(query, target);
      const results = response.data.data;
      this.setState({
        loadedResults: true,
        results,
      });
    } else {
      this.setState({
        loadedResults: true,
        results: [],
      });
    }
  };

  render() {
    const { query, target } = this.props;
    const { loadedResults, results } = this.state;

    if (!loadedResults) {
      return <CircularLoadingScreen thickness={5} />;
    }

    if (target == "posts") {
      return (
        <div>
          {results.length == 0 ? (
            <Fragment>
              <p style={paddingStyle}>No results found</p>
            </Fragment>
          ) : (
            <Fragment>
              <h3 className="heading" style={paddingStyle}>
                Showing posts for "{query}"
              </h3>
              {results.map((post) => (
                <Post post={post} key={post.id} />
              ))}
            </Fragment>
          )}
        </div>
      );
    } else if (target == "users") {
      return (
        <div>
          {results.length == 0 ? (
            <Fragment>
              <p style={paddingStyle}>No results found</p>
            </Fragment>
          ) : (
            <Fragment>
              <h3 className="heading" style={paddingStyle}>
                Showing users for "{query}"
              </h3>
              {results.map((user) => (
                <Link
                  to={`/profile/${user.username}`}
                  style={{
                    color: "initial",
                    textDecoration: "none",
                  }}
                  key={user.id}
                >
                  <User user={user} />
                </Link>
              ))}
            </Fragment>
          )}
        </div>
      );
    } else {
      return <p style={paddingStyle}>No results found</p>;
    }
  }
}

export default SearchResults;
